//Created by https://github.com/agelospanagiotakis
import { surveyLocalization } from "../surveyStrings";

export var greekSurveyStrings = {
  pagePrevText: "Προηγούμενο",
  pageNextText: "Επόμενο",
  completeText: "Ολοκλήρωση",
  otherItemText: "Άλλο (παρακαλώ διευκρινίστε)",
  progressText: "Σελίδα {0} από {1}",
  emptySurvey:
    "Δεν υπάρχει καμία ορατή σελίδα ή ορατή ερώτηση σε αυτό το ερωτηματολόγιο.",
  completingSurvey:
    "Ευχαριστούμε για την συμπλήρωση αυτού του ερωτηματολογίου!",
  loadingSurvey: "Το ερωτηματολόγιο φορτώνεται απο το διακομιστή...",
  optionsCaption: "Επιλέξτε...",
  requiredError: "Παρακαλώ απαντήστε στην ερώτηση.",
  requiredInAllRowsError:
    "Παρακαλώ απαντήστε στις ερωτήσεις σε όλες τις γραμμές.",
  numericError: "Η τιμή πρέπει να είναι αριθμητική.",
  textMinLength: "Παρακαλώ συμπληρώστε τουλάχιστον {0} σύμβολα.",
  minRowCountError: "Παρακαλώ συμπληρώστε τουλάχιστον {0} γραμμές.",
  minSelectError: "Παρακαλώ επιλέξτε τουλάχιστον {0} παραλλαγές.",
  maxSelectError: "Παρακαλώ επιλέξτε όχι παραπάνω απο {0} παραλλαγές.",
  numericMinMax:
    "Το '{0}' θα πρέπει να είναι ίσο ή μεγαλύτερο απο το {1} και ίσο ή μικρότερο απο το {2}",
  numericMin: "Το '{0}' πρέπει να είναι μεγαλύτερο ή ισο με το {1}",
  numericMax: "Το '{0}' πρέπει να είναι μικρότερο ή ίσο απο το {1}",
  invalidEmail: "Παρακαλώ δώστε μια αποδεκτή διεύθυνση e-mail.",
  urlRequestError: "Η αίτηση επέστρεψε σφάλμα '{0}'. {1}",
  urlGetChoicesError:
    "Η αίτηση επέστρεψε κενά δεδομένα ή η ιδιότητα 'μονοπάτι/path' είναι εσφαλμένη",
  exceedMaxSize: "Το μέγεθος δεν μπορεί να υπερβαίνει τα {0}.",
  otherRequiredError: "Παρακαλώ συμπληρώστε την τιμή για το πεδίο 'άλλο'.",
  uploadingFile:
    "Το αρχείο σας ανεβαίνει. Παρακαλώ περιμένετε καποια δευτερόλεπτα και δοκιμάστε ξανά.",
  addRow: "Προσθήκη γραμμής",
  removeRow: "Αφαίρεση"
};
surveyLocalization.locales["gr"] = greekSurveyStrings;
surveyLocalization.localeNames["gr"] = "ελληνικά";



// WEBPACK FOOTER //
// ./src/localization/greek.ts